import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../views/Login/Login";

const OpenRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default OpenRoutes;
